import { Box, Typography } from "@mui/material";


export default function RedirectButton({setContent, content, label, text}) {
  return (
    <Box sx={{display: "block" }}>
      <Box>
        <Typography variant="h4" sx={{fontSize:"20px", marginBottom:"15px", textAlign:"center" }}>{text}</Typography>
      </Box>
      <Box onClick={()=>setContent(content)} sx={{background: "#000038",
              display:"flex",
              py:"10px",
              px:"5px",
              margin:"auto",
              width:"220px",
              justifyContent:"center",
              alignItems:"center",
              borderRadius:"10px",
              color: "#ffffff",
              cursor: "pointer",
              "&:hover": { background: "#05b67f", color: "#ffffff" }
            }}>
            {label}
      </Box>
    </Box>
    
  )
}
